module.exports = __webpack_public_path__ + "img/red-star.d1083375.svg";